(function () {
  'use strict';

  /* =============================================================
     CONFIG & STATE
     ============================================================= */
  var cfg = window.GRFQIAConfigs || {};
  var APP_URL = (cfg.app_url || '').replace(/\/$/, '');
  var SHOP = cfg.shop_url || '';
  var COOKIE = SHOP + 'quote.id';
  var MONEY = cfg.money_format || '$';

  var root = document.querySelector('[data-quote-root]');
  if (!root) return;

  // GRFQ's quote markup is parsed into a detached document and only ever read
  // (text and attributes); it is never inserted into the page. [data-grfq-host]
  // stays in the section as an empty marker.
  var hostDoc = null;
  var listEl = root.querySelector('[data-quote-items-list]');
  var emptyListEl = root.querySelector('[data-quote-items-empty]');

  var state = { items: [] };
  var productCache = {};
  var historyLoaded = false;

  // Copy comes from snippets/quote-i18n.liquid; the fallbacks below only cover it being absent.
  var I18N = window.QuoteI18n || {};
  var I18N_FALLBACK = {
    'items.count_one': '%count% item',
    'items.count_other': '%count% items',
    'items.sku': 'SKU: %sku%',
    'items.manual_note': "Manually entered — we'll confirm details in your quote",
    'items.pending_confirmation': 'Pending confirmation',
    'items.delivery': 'Delivery %estimate%',
    'items.remove': 'Remove item',
    'items.untitled': '(item)',
    'items.tbd': 'TBD',
    'qty.label': 'Quantity',
    'qty.decrease': 'Decrease quantity',
    'qty.increase': 'Increase quantity',
    'summary.catalog_items_count': 'Catalog items (%count%)',
    'summary.manual_entries_count': 'Manual entries (%count%)',
    'submitted.email_fallback': 'your email',
    'submitted.pricing_tbd': 'pricing TBD',
    'urgency.urgent': 'Urgent',
    'urgency.standard': 'Standard',
    'history.quote_ref': 'Quote #%ref%',
    'history.view': 'View',
    'history.back': 'Back to quotes',
    'history.contact_information': 'Contact information',
    'history.items_count': 'Items (%count%)',
    'errors.form_loading': 'Quote form is still loading — please try again in a moment.',
    'errors.submit_failed': 'Sorry — your quote could not be submitted. Please review the form and try again.',
    'errors.network': 'Network error while submitting your quote. Please try again.',
    'errors.unexpected': 'Something went wrong preparing your request. Please try again.'
  };

  function t(key, vars) {
    var s = I18N[key];
    if (typeof s !== 'string' || s === '') s = I18N_FALLBACK[key] || '';
    if (vars) Object.keys(vars).forEach(function (k) {
      s = s.split('%' + k + '%').join(vars[k] == null ? '' : String(vars[k]));
    });
    return s;
  }
  function itemCount(n) { return t(n === 1 ? 'items.count_one' : 'items.count_other', { count: n }); }

  /* =============================================================
     PLUMBING — cookies, formatting, transport (no app behaviour)
     ============================================================= */
  function $jq() { return window.spuritJQIA || null; }

  function getCookie(name) {
    var key = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var m = document.cookie.match('(?:^|; )' + key + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value) {
    var d = new Date(); d.setTime(d.getTime() + 7 * 864e5);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }
  function clearQuoteCookie() {
    setCookie(COOKIE, '');
    document.cookie = COOKIE + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }
  function quoteId() { return getCookie(COOKIE); }
  function isLoggedIn() { return !!(cfg.customer && cfg.customer.id && String(cfg.customer.id) !== '0'); }

  function money(cents) {
    return MONEY + ((Number(cents) || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function setText(sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }

  // GRFQ server talks JSONP through its bundled jQuery.
  function call(path, type, data) {
    return new Promise(function (resolve) {
      var $ = $jq();
      if (!$) { resolve(null); return; }
      $.ajax({ url: APP_URL + path, type: type, dataType: 'jsonp', data: data, success: resolve, error: function () { resolve(null); } });
    });
  }
  // Same-origin Shopify catalog lookup for live price + image (cached per handle).
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function customerParams() {
    var c = cfg.customer || {}, p = '';
    if (c.name) p += '&customer_name=' + encodeURIComponent(c.name);
    if (c.email) p += '&customer_email=' + encodeURIComponent(c.email);
    if (c.id) p += '&customer_id=' + encodeURIComponent(c.id);
    return p;
  }

  /* =============================================================
     PARSING — read GRFQ's HTML into plain data (no DOM writes)
     ============================================================= */
  // Vendor HTML -> inert document: nothing in it runs or loads, and only
  // textContent / attributes are read back from it.
  function parseVendorHtml(html) {
    try { return new DOMParser().parseFromString(String(html == null ? '' : html), 'text/html'); }
    catch (e) { return null; }
  }
  function hostQuery(sel) { return hostDoc ? hostDoc.querySelector(sel) : null; }
  function hostQueryAll(sel) { return hostDoc ? Array.prototype.slice.call(hostDoc.querySelectorAll(sel)) : []; }
  function collapse(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function digits(v) { v = collapse(v); return /^\d+$/.test(v) ? v : ''; }
  function token(v) { v = collapse(v); return /^[A-Za-z0-9_-]+$/.test(v) ? v : ''; }
  function safeImageUrl(v) { v = collapse(v); return /^(https?:)?\/\/[^\s"'<>]+$/i.test(v) ? v : ''; }

  function isManual(item) { return !item.productId || item.productId === '0'; }

  // GRFQ option lines → a delivery line + condition tags.
  function classifyOptions(options, manual) {
    var delivery = '', tags = [];
    options.forEach(function (text) {
      // Option text is app-supplied; only our wrapper copy is translatable.
      if (/estimat|deliver|ship|order/i.test(text)) delivery = t('items.delivery', { estimate: text.replace(/^order estimation:\s*/i, '') });
      else tags.push({ label: text, variant: /certified|refurb|new|tested/i.test(text) ? 'brand' : 'neutral' });
    });
    if (manual) tags.unshift({ label: t('items.pending_confirmation'), variant: 'danger' });
    return { delivery: delivery, tags: tags };
  }

  // Active quote table (inside the hidden #rfq_form) → item objects.
  function parseItems() {
    if (!hostDoc) return [];
    try {
    var rows = hostQueryAll('#rfq_form .rfq-table tbody tr.cart__row');
    // Markup drift: rows that no longer match are still read as data, never shown as-is.
    if (!rows.length) rows = hostQueryAll('.rfq-table tbody tr');
    return rows.map(
      function (tr) {
        var hm = (tr.outerHTML || '').match(/\/products\/([a-z0-9][a-z0-9\-_]*)/i);
        var titleEl = tr.querySelector('.item_title') || tr.querySelector('td');
        var img = tr.querySelector('.item_image img');
        var rawImg = safeImageUrl(img ? img.getAttribute('src') : '');
        if (/no-image|globosoftware\.net\/images/i.test(rawImg)) rawImg = '';
        var qtyInput = tr.querySelector('.item_qty');
        var skuEl = tr.querySelector('.item_sku');
        return {
          id: token(tr.getAttribute('data-id')),
          productId: digits(tr.getAttribute('data-product-id')),
          variantId: digits(tr.getAttribute('data-variant-id')),
          handle: hm ? hm[1] : '',
          title: (titleEl && collapse(titleEl.textContent)) || t('items.untitled'),
          sku: skuEl ? collapse(skuEl.textContent) : '',
          image: rawImg,
          qty: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
          options: Array.prototype.map.call(tr.querySelectorAll('.item_option li'), function (li) { return collapse(li.textContent); }).filter(Boolean),
          unitPrice: null
        };
      }
    );
    } catch (e) { return []; }
  }

  // /history HTML → submission rows.
  function parseHistoryRows(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.prototype.map.call(doc.querySelectorAll('.rfq-table tbody tr'), function (tr) {
        var tds = tr.querySelectorAll('td');
        var a = tr.querySelector('a[onclick*="viewQuote"]');
        var m = a && (a.getAttribute('onclick') || '').match(/viewQuote\((\d+)\)/);
        return {
          ref: tds[0] ? tds[0].textContent.trim() : '',
          date: tds[1] ? tds[1].textContent.trim() : '',
          email: tds[2] ? tds[2].textContent.trim() : '',
          id: m ? m[1] : ''
        };
      });
    } catch (e) { return []; }
  }

  // /viewquote HTML → a single submitted quote (contact + items).
  function parseQuoteDetail(html) {
    try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var h1 = doc.querySelector('h1');
    var ref = '', date = '';
    if (h1) { var p = h1.textContent.split('|'); ref = (p[0] || '').trim(); date = (p[1] || '').trim(); }
    var contact = Array.prototype.map.call(doc.querySelectorAll('.form-list tr'), function (tr) {
      var l = tr.querySelector('.label'), v = tr.querySelector('.value');
      return { label: l ? l.textContent.trim() : '', value: v ? v.textContent.trim() : '' };
    }).filter(function (r) { return r.label && r.value; });
    var items = Array.prototype.map.call(doc.querySelectorAll('table.table tbody tr'), function (tr) {
      var tds = tr.querySelectorAll('td');
      var img = tr.querySelector('img'), opt = tr.querySelector('.item_option');
      return {
        image: safeImageUrl(img ? img.getAttribute('src') : ''),
        title: tds[1] ? tds[1].textContent.trim() : (tds[0] ? tds[0].textContent.trim() : ''),
        option: opt ? opt.textContent.trim() : '',
        qty: tds.length ? tds[tds.length - 1].textContent.trim() : '1'
      };
    });
    return { ref: ref, date: date, contact: contact, items: items };
    } catch (e) { return { ref: '', date: '', contact: [], items: [] }; }
  }

  /* =============================================================
     VIEW — build markup + insert into the DOM (no decisions)
     ============================================================= */
  var ICON = {
    minus: '<svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14"/></svg>',
    plus: '<svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/></svg>',
    trash: '<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/></svg>',
    truck: '<svg class="w-5 h-5 shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.1549 3.82147C2.46746 3.50891 2.89139 3.33331 3.33341 3.33331H10.0001C10.4421 3.33331 10.866 3.50891 11.1786 3.82147C11.4912 4.13403 11.6667 4.55795 11.6667 4.99998H15.8334C16.1491 4.99998 16.4376 5.17831 16.5788 5.46063L18.2454 8.79397C18.3033 8.90968 18.3334 9.03728 18.3334 9.16665V12.5C18.3334 12.9602 17.9603 13.3333 17.5001 13.3333H17.0539C17.0733 13.4694 17.0834 13.6085 17.0834 13.75C17.0834 15.3608 15.7776 16.6666 14.1667 16.6666C12.5559 16.6666 11.2501 15.3608 11.2501 13.75C11.2501 13.6085 11.2602 13.4694 11.2796 13.3333H8.72054C8.74001 13.4694 8.75008 13.6085 8.75008 13.75C8.75008 15.3608 7.44425 16.6666 5.83341 16.6666C4.22258 16.6666 2.91675 15.3608 2.91675 13.75C2.91675 13.6085 2.92682 13.4694 2.94629 13.3333H2.50008C2.03984 13.3333 1.66675 12.9602 1.66675 12.5V4.99998C1.66675 4.55795 1.84234 4.13403 2.1549 3.82147ZM4.82675 13.0088C4.83125 13.003 4.83569 12.9971 4.84004 12.9911C5.06847 12.6925 5.42846 12.5 5.83341 12.5C6.23837 12.5 6.59835 12.6925 6.82678 12.9911C6.83114 12.9971 6.83558 13.003 6.84009 13.0088C6.99302 13.2162 7.08341 13.4725 7.08341 13.75C7.08341 14.4403 6.52377 15 5.83341 15C5.14306 15 4.58341 14.4403 4.58341 13.75C4.58341 13.4725 4.67381 13.2162 4.82675 13.0088ZM7.87466 11.6666C7.3486 11.1512 6.62813 10.8333 5.83341 10.8333C5.0387 10.8333 4.31823 11.1512 3.79217 11.6666H3.33341V4.99998H10.0001V11.6666H7.87466ZM12.1255 11.6666H11.6667V6.66665H15.3184L16.1517 8.33331H13.3334C12.8732 8.33331 12.5001 8.70641 12.5001 9.16665C12.5001 9.62688 12.8732 9.99998 13.3334 9.99998H16.6667V11.6666H16.208C15.6819 11.1512 14.9615 10.8333 14.1667 10.8333C13.372 10.8333 12.6516 11.1512 12.1255 11.6666ZM13.1601 13.0088C13.1646 13.003 13.169 12.9971 13.1734 12.9911C13.4018 12.6925 13.7618 12.5 14.1667 12.5C14.5717 12.5 14.9317 12.6925 15.1601 12.9911C15.1645 12.9971 15.1689 13.003 15.1734 13.0088C15.3264 13.2162 15.4167 13.4725 15.4167 13.75C15.4167 14.4403 14.8571 15 14.1667 15C13.4764 15 12.9167 14.4403 12.9167 13.75C12.9167 13.4725 13.0071 13.2162 13.1601 13.0088Z" fill="#4D58AD"/></svg>',
    box: '<svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"/></svg>',
    spinner: '<span class="inline-block w-8 h-8 border-2 border-zinc-200 border-t-[#5c6ac4] rounded-full animate-spin"></span>'
  };

  function productHref(item) {
    return item.handle ? '/products/' + item.handle + (item.variantId ? '?variant=' + item.variantId : '') : '';
  }
  function tagHtml(tag) {
    var cls = {
      brand: 'bg-[#f0f1fb] border-[#c9cdf0] text-[#353c78]',
      success: 'bg-[#f0fdf4] border-[#b9f8cf] text-[#016630]',
      danger: 'bg-[#fff8f1] border-[#fcd9bd] text-[#771d1d]',
      neutral: 'bg-white border-zinc-200 text-zinc-900'
    }[tag.variant] || 'bg-white border-zinc-200 text-zinc-900';
    return '<span class="inline-flex items-center px-1 py-0.5 rounded-sm border text-xs font-medium ' + cls + '">' + esc(tag.label) + '</span>';
  }
  function thumbHtml(item) {
    var inner = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" width="64" height="64" class="w-16 h-16 rounded-lg object-cover bg-zinc-100 border border-zinc-200" loading="lazy">'
      : '<span class="w-16 h-16 rounded-lg bg-zinc-100 border border-zinc-200 flex items-center justify-center text-zinc-300">' + ICON.box + '</span>';
    var href = productHref(item);
    return href ? '<a href="' + href + '" class="block shrink-0">' + inner + '</a>' : inner;
  }

  function cardHtml(item) {
    var manual = isManual(item);
    var meta = classifyOptions(item.options, manual);
    var href = productHref(item);
    var title = href ? '<a href="' + href + '" class="hover:text-[#5c6ac4] hover:underline">' + esc(item.title) + '</a>' : esc(item.title);
    var tags = meta.tags.length ? '<div class="flex flex-wrap items-center gap-1.5">' + meta.tags.map(tagHtml).join('') + '</div>' : '';
    var delivery = meta.delivery ? '<p class="flex items-center gap-1.5 m-0 text-sm font-normal text-zinc-500">' + ICON.truck + '<span>' + esc(meta.delivery) + '</span></p>' : '';
    var subtitle = manual
      ? '<p class="m-0 text-sm font-normal text-zinc-500 truncate">' + esc(t('items.manual_note')) + '</p>'
      : '<p class="m-0 text-sm font-normal text-zinc-500 truncate empty:hidden" data-item-sku>' + (item.sku ? esc(t('items.sku', { sku: item.sku })) : '') + '</p>';

    return '' +
      '<div class="flex flex-col sm:flex-row gap-4 p-4 bg-white border border-zinc-200 rounded-xl" data-quote-item data-item-id="' + esc(item.id) + '">' +
        '<div class="flex gap-4 flex-1 min-w-0">' +
          '<span class="shrink-0" data-item-thumb>' + thumbHtml(item) + '</span>' +
          '<div class="flex-1 min-w-0 flex flex-col gap-2">' +
            '<h3 class="text-base sm:text-lg font-bold text-zinc-900 truncate m-0">' + title + '</h3>' +
            subtitle + tags + delivery +
          '</div>' +
        '</div>' +
        '<div class="flex items-center justify-between gap-4 sm:justify-end shrink-0">' +
          '<div class="inline-flex items-center gap-2" data-qty-stepper>' +
            '<button type="button" class="flex items-center justify-center w-10 h-10 shrink-0 rounded text-zinc-500 hover:bg-zinc-100 transition-colors" aria-label="' + esc(t('qty.decrease')) + '" data-qty-decrement>' + ICON.minus + '</button>' +
            '<input type="number" min="1" value="' + item.qty + '" inputmode="numeric" class="w-[52px] h-10 text-center text-sm text-zinc-900 bg-white border border-zinc-200 rounded focus:outline-none focus:ring-1 focus:ring-[#5c6ac4] focus:border-[#5c6ac4]" aria-label="' + esc(t('qty.label')) + '" data-item-qty data-item-id="' + esc(item.id) + '">' +
            '<button type="button" class="flex items-center justify-center w-10 h-10 shrink-0 rounded text-zinc-500 hover:bg-zinc-100 transition-colors" aria-label="' + esc(t('qty.increase')) + '" data-qty-increment>' + ICON.plus + '</button>' +
          '</div>' +
          '<span class="text-base font-bold text-zinc-900 tabular-nums w-20 text-right" data-item-price>' + (manual ? esc(t('items.tbd')) : '…') + '</span>' +
          '<button type="button" class="inline-flex items-center justify-center w-9 h-9 text-zinc-400 hover:text-red-600 transition-colors" aria-label="' + esc(t('items.remove')) + '" data-item-remove data-item-id="' + esc(item.id) + '">' + ICON.trash + '</button>' +
        '</div>' +
      '</div>';
  }

  function historyCardHtml(row) {
    var view = row.id
      ? '<button type="button" data-view-quote="' + esc(row.id) + '" class="inline-flex items-center justify-center gap-1.5 font-medium whitespace-nowrap transition-colors bg-white border border-zinc-200 text-zinc-600 hover:bg-zinc-50 shadow-sm rounded text-sm px-4 py-2.5 shrink-0">' + esc(t('history.view')) + '</button>'
      : '';
    return '<div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 bg-white border border-zinc-200 rounded-xl">' +
        '<div class="min-w-0">' +
          '<p class="text-sm font-bold text-zinc-900">' + esc(t('history.quote_ref', { ref: row.ref })) + '</p>' +
          '<p class="text-xs text-zinc-500 mt-0.5">' + esc(row.date) + (row.email ? ' · ' + esc(row.email) : '') + '</p>' +
        '</div>' + view +
      '</div>';
  }

  function detailHtml(d) {
    var contact = d.contact.map(function (c) {
      return '<div class="flex justify-between gap-4 py-1.5"><dt class="text-zinc-500">' + esc(c.label) + '</dt><dd class="font-medium text-zinc-900 text-right">' + esc(c.value) + '</dd></div>';
    }).join('');
    var items = d.items.map(function (it) {
      var thumb = it.image
        ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" class="w-12 h-12 rounded-lg object-cover bg-zinc-100 border border-zinc-200 shrink-0">'
        : '<span class="w-12 h-12 rounded-lg bg-zinc-100 border border-zinc-200 shrink-0"></span>';
      var opt = it.option ? '<span class="inline-flex items-center px-1 py-0.5 mt-1 rounded-sm border bg-[#f0f1fb] border-[#c9cdf0] text-[#353c78] text-xs font-medium">' + esc(it.option) + '</span>' : '';
      return '<div class="flex items-center gap-3 p-3 border border-zinc-200 rounded-xl">' + thumb +
          '<div class="flex-1 min-w-0"><p class="m-0 text-sm font-semibold text-zinc-900 truncate">' + esc(it.title) + '</p>' + opt + '</div>' +
          '<span class="text-sm text-zinc-500 shrink-0 font-normal">x' + esc(it.qty) + '</span>' +
        '</div>';
    }).join('');
    return '' +
      '<button type="button" data-quote-detail-close class="inline-flex items-center gap-1.5 text-sm font-medium text-[#5c6ac4] hover:underline mb-3">' +
        '<svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/></svg>' +
        esc(t('history.back')) +
      '</button>' +
      '<div class="mb-3"><h3 class="text-lg font-bold text-zinc-900">' + esc(t('history.quote_ref', { ref: d.ref })) + '</h3>' + (d.date ? '<p class="text-sm text-zinc-500">' + esc(d.date) + '</p>' : '') + '</div>' +
      '<div class="bg-white border border-zinc-200 rounded-xl p-5 mb-3">' +
        '<h4 class="text-base font-medium text-zinc-900 mb-2">' + esc(t('history.contact_information')) + '</h4>' +
        '<dl class="text-sm divide-y divide-zinc-100">' + contact + '</dl>' +
      '</div>' +
      '<div class="bg-white border border-zinc-200 rounded-xl p-5">' +
        '<h4 class="text-base font-medium text-zinc-900 mb-3">' + esc(t('history.items_count', { count: d.items.length })) + '</h4>' +
        '<div class="flex flex-col gap-3">' + items + '</div>' +
      '</div>';
  }

  // Vendor markup we do not recognise: show its text through textContent only.
  function renderVendorText(el, html) {
    if (!el) return;
    var doc = parseVendorHtml(html);
    var text = doc && doc.body ? collapse(doc.body.textContent) : '';
    el.textContent = '';
    if (!text) return;
    var p = document.createElement('p');
    p.className = 'text-sm text-zinc-500';
    p.textContent = text;
    el.appendChild(p);
  }

  function show(screen) {
    root.querySelectorAll('[data-quote-screen]').forEach(function (el) {
      el.classList.toggle('hidden', el.getAttribute('data-quote-screen') !== screen);
    });
    // The history screen has its own heading, so hide the page header + history button there.
    var historyBtn = root.querySelector('[data-quote-history-btn]');
    if (historyBtn) historyBtn.classList.toggle('hidden', screen === 'history');
    var pageHeader = root.querySelector('[data-quote-page-header]');
    if (pageHeader) pageHeader.classList.toggle('hidden', screen === 'history');
  }

  function renderItems() {
    var items = state.items;
    if (listEl) { listEl.innerHTML = items.map(cardHtml).join(''); listEl.classList.toggle('hidden', items.length === 0); }
    if (emptyListEl) emptyListEl.classList.toggle('hidden', items.length > 0);
    root.querySelectorAll('[data-quote-count]').forEach(function (el) {
      el.textContent = itemCount(items.length);
    });
  }

  function recomputeTotals() {
    var items = state.items, catalogCents = 0, hasUnknown = false, manualCount = 0, catalogCount = 0;
    items.forEach(function (it) {
      if (isManual(it)) { manualCount++; hasUnknown = true; return; }
      catalogCount++;
      if (typeof it.unitPrice === 'number' && it.unitPrice > 0) catalogCents += it.unitPrice * it.qty;
      else hasUnknown = true;
    });
    setText('[data-quote-catalog-label]', t('summary.catalog_items_count', { count: catalogCount }));
    setText('[data-quote-manual-label]', t('summary.manual_entries_count', { count: manualCount }));
    setText('[data-quote-catalog-total]', catalogCount ? (catalogCents > 0 ? money(catalogCents) : t('items.tbd')) : '—');
    setText('[data-quote-manual-total]', manualCount ? t('items.tbd') : '—');
    setText('[data-quote-total]', (catalogCents > 0 ? money(catalogCents) : (items.length ? t('items.tbd') : '—')) + (catalogCents > 0 && hasUnknown ? '+' : ''));
  }

  // Fill each product row's price + (fallback) image from the live catalog.
  function enrich() {
    state.items.forEach(function (item) {
      var card = listEl && listEl.querySelector('[data-item-id="' + item.id + '"]');
      var priceEl = card && card.querySelector('[data-item-price]');
      if (isManual(item) || !item.handle) { if (priceEl) priceEl.textContent = t('items.tbd'); return; }
      fetchProduct(item.handle).then(function (prod) {
        try {
          if (!prod) { item.unitPrice = 0; if (priceEl) priceEl.textContent = t('items.tbd'); recomputeTotals(); return; }
          var v = (prod.variants || []).filter(function (x) { return String(x.id) === String(item.variantId); })[0] || (prod.variants || [])[0];
          item.unitPrice = v ? Number(v.price) : 0;
          if (priceEl) priceEl.textContent = item.unitPrice > 0 ? money(item.unitPrice * item.qty) : t('items.tbd');
          if (!item.sku && v && v.sku) {
            item.sku = v.sku;
            var skuEl = card && card.querySelector('[data-item-sku]');
            if (skuEl) skuEl.textContent = t('items.sku', { sku: v.sku });
          }
          if (!item.image) {
            var imgUrl = (v && v.featured_image && v.featured_image.src) || prod.featured_image || (prod.images && prod.images[0]);
            if (imgUrl) { item.image = imgUrl; var thumb = card && card.querySelector('[data-item-thumb]'); if (thumb) thumb.innerHTML = thumbHtml(item); }
          }
          recomputeTotals();
        } catch (e) { if (priceEl) priceEl.textContent = t('items.tbd'); }
      });
    });
    recomputeTotals();
  }

  function fillConfirmation() {
    try {
    var emailEl = root.querySelector('[name="email"]');
    setText('[data-confirm-email]', (emailEl && emailEl.value.trim()) || t('submitted.email_fallback'));
    var qid = quoteId();
    setText('[data-confirm-ref]', qid ? '#' + qid : '—');
    var catalogCents = 0, hasUnknown = false, manual = 0, catalog = 0;
    state.items.forEach(function (it) {
      if (isManual(it)) { manual++; return; }
      catalog++;
      if (typeof it.unitPrice === 'number' && it.unitPrice > 0) catalogCents += it.unitPrice * it.qty;
      else hasUnknown = true;
    });
    setText('[data-confirm-catalog]', catalog + ' · ' + (catalogCents > 0 ? money(catalogCents) + (hasUnknown ? '+' : '') : t('submitted.pricing_tbd')));
    setText('[data-confirm-manual]', manual + ' · ' + t('submitted.pricing_tbd'));
    var u = (root.querySelector('[name="urgency"]:checked') || {}).value;
    setText('[data-confirm-urgency]', u === 'urgent' ? t('urgency.urgent') : t('urgency.standard'));
    } catch (e) {}
  }

  function renderHistoryList(rows) {
    var box = root.querySelector('[data-quote-history-list]');
    if (!box || !rows.length) return;
    box.innerHTML = '<div class="flex flex-col gap-3">' + rows.map(historyCardHtml).join('') + '</div>';
  }

  function renderDetail(d) {
    var el = root.querySelector('[data-quote-detail]');
    if (!el) return;
    el.innerHTML = detailHtml(d);
    el.classList.remove('hidden');
  }
  function showDetailLoading() {
    var el = root.querySelector('[data-quote-detail]');
    if (!el) return;
    var main = root.querySelector('[data-quote-history-main]');
    if (main) main.classList.add('hidden');           // swap the list out for the detail
    el.innerHTML = '<div class="py-10 text-center">' + ICON.spinner + '</div>';
    el.classList.remove('hidden');
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function hideDetail() {
    var el = root.querySelector('[data-quote-detail]');
    if (el) { el.classList.add('hidden'); el.innerHTML = ''; }
    var main = root.querySelector('[data-quote-history-main]');
    if (main) main.classList.remove('hidden');         // back to the list
  }

  /* =============================================================
     LOGIC — the real behaviour: screen decisions + GRFQ actions
     ============================================================= */

  // empty | items | submitted | history (history is logged-in only).
  function decideScreen(count) {
    var req = new URLSearchParams(location.search).get('quote_screen');
    if (req === 'submitted' || req === 'empty' || req === 'items') return req;
    if (req === 'history') return isLoggedIn() ? 'history' : 'empty';
    if (count > 0) return 'items';
    return 'empty';
  }

  // Re-read the active quote from GRFQ, repaint, reveal the right screen.
  function render() {
    try {
      state.items = parseItems();
      renderItems();
      enrich();
      var screen = decideScreen(state.items.length);
      if (screen === 'history') loadHistory();
      show(screen);
    } catch (e) { show('empty'); }
  }

  function refresh() {
    var qid = quoteId();
    if (!qid) { render(); return Promise.resolve(); }
    return call('/getmainform', 'POST', 'shop=' + SHOP + '&quote=' + qid + customerParams())
      .then(function (res) { if (res && res.success) hostDoc = parseVendorHtml(res.html); render(); });
  }

  // Ask GRFQ to repaint its site-wide quote-count badges (.quoteCount) from /numitem.
  function refreshQuoteBadge() {
    if (window.GRFQIA && typeof window.GRFQIA.UpdateQuoteCart === 'function') window.GRFQIA.UpdateQuoteCart();
  }
  function afterAdd(res) {
    if (res && res.success && res.quote) setCookie(COOKIE, res.quote);
    refreshQuoteBadge();
    return refresh();
  }
  function addProduct(o) {
    var v = o.variantId;
    var url = o.handle ? '//' + SHOP + '/products/' + o.handle + (v ? '?variant=' + v : '') : '';
    var data = 'product_id=' + encodeURIComponent(o.productId) + '&shop=' + SHOP;
    if (v) data += '&variant_id=' + encodeURIComponent(v);
    if (o.sku) data += '&sku=' + encodeURIComponent(o.sku);
    if (o.vendor) data += '&vendor=' + encodeURIComponent(o.vendor);
    data += '&qty=' + (o.qty || 1) + '&name=' + encodeURIComponent(o.title || '');
    if (o.image) data += '&image=' + encodeURIComponent(o.image);
    data += '&product_url=' + encodeURIComponent(url);
    if (o.price != null && o.price !== '') data += '&price=' + encodeURIComponent(o.price);
    if (o.option && !/^default title$/i.test(o.option)) data += '&option=' + encodeURIComponent(o.option);
    var qid = quoteId(); if (qid) data += '&quote=' + qid;
    return call('/add', 'GET', data).then(afterAdd);
  }
  function addCustom(name, qty) {
    // Free text goes to the vendor as a part number: no angle brackets or control characters.
    name = String(name == null ? '' : name).replace(/[<>\u0000-\u001f]/g, '').trim().slice(0, 200);
    if (!name) return Promise.resolve(null);
    var data = 'product_id=0&name=' + encodeURIComponent(name) + '&image=&option=&qty=' + (qty || 1) + '&shop=' + SHOP;
    var qid = quoteId(); if (qid) data += '&quote=' + qid;
    return call('/add', 'GET', data).then(afterAdd);
  }

  // Read an add group (predictive pick or free text) and add to the quote.
  function addFromGroup(group) {
    if (!group) return;
    var skuSearch = group.querySelector('sku-search');
    var input = group.querySelector('[data-sku-input]');
    var term = input ? input.value.trim() : '';
    if (!term) { if (input) input.focus(); return; }

    var qtyInput = group.querySelector('input[data-quote-add-qty], [data-quote-add-qty] input[type="number"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var get = function (k) { return skuSearch && skuSearch.getAttribute('data-picked-' + k); };
    var pid = get('product');
    var add = pid
      ? addProduct({ productId: pid, variantId: get('variant'), title: get('title') || term, qty: qty,
          handle: get('handle'), image: get('image'), sku: get('sku'), vendor: get('vendor'), price: get('price'), option: get('option') })
      : addCustom(term, qty);

    add.then(function () {
      if (input) input.value = '';
      if (skuSearch) ['product', 'variant', 'title', 'handle', 'image', 'sku', 'vendor', 'price', 'option'].forEach(function (k) { skuSearch.removeAttribute('data-picked-' + k); });
      show('items');
    });
  }

  function updateQty(id, qty) {
    if (window.GRFQIA && typeof window.GRFQIA.UpdateQuantity === 'function') window.GRFQIA.UpdateQuantity(id, qty);
    else call('/updateqty', 'GET', '&quote_item_id=' + id + '&qty=' + qty);

    var hidden = hostQuery('.item_qty[name="qty[' + id + ']"]');
    if (hidden) hidden.value = qty;
    var item = state.items.filter(function (i) { return i.id === id; })[0];
    if (item) {
      item.qty = qty;
      var priceEl = listEl && listEl.querySelector('[data-item-id="' + id + '"] [data-item-price]');
      if (priceEl && typeof item.unitPrice === 'number' && item.unitPrice > 0) priceEl.textContent = money(item.unitPrice * qty);
      recomputeTotals();
    }
  }

  function removeItem(id) {
    var done;
    if (window.GRFQIA && typeof window.GRFQIA.remove === 'function') {
      window.GRFQIA.remove(null, id);
      done = new Promise(function (r) { setTimeout(r, 400); });
    } else {
      var qid = quoteId();
      done = call('/delete', 'GET', 'shop=' + SHOP + '&item_id=' + id + (qid ? '&quote=' + qid : ''));
    }
    done.then(function () { refresh(); refreshQuoteBadge(); });
  }

  function loadHistory() {
    if (historyLoaded || !isLoggedIn()) return;
    historyLoaded = true;
    var box = root.querySelector('[data-quote-history-list]');
    call('/history', 'POST', 'customer=' + encodeURIComponent(cfg.customer.id) + '&shop=' + SHOP)
      .then(function (res) {
        if (!res || !res.html || !box) return;
        var rows = parseHistoryRows(res.html);
        if (rows.length) renderHistoryList(rows);
        else renderVendorText(box, res.html); // unexpected format: its text only, never its markup
      });
  }

  function viewQuote(id) {
    showDetailLoading();
    call('/viewquote', 'POST', 'id=' + encodeURIComponent(id) + '&shop=' + SHOP)
      .then(function (res) {
        if (!res || !res.html) { hideDetail(); return; }
        var d = parseQuoteDetail(res.html);
        if (d.contact.length || d.items.length) { renderDetail(d); return; }
        // Unexpected format: theme chrome plus the response's text, never its markup.
        var el = root.querySelector('[data-quote-detail]');
        if (el) {
          el.innerHTML = detailHtml({ ref: id, date: '', contact: [], items: [] });
          var textBox = document.createElement('div');
          textBox.className = 'mt-3 text-sm text-zinc-500';
          renderVendorText(textBox, res.html);
          el.appendChild(textBox);
          el.classList.remove('hidden');
        }
      });
  }

  // The GRFQ form must post back to the quote app, nowhere else.
  function vendorAction(form) {
    try {
      var action = new URL(form.getAttribute('action') || '', APP_URL || location.href);
      var appHost = APP_URL ? new URL(APP_URL).host : '';
      var appRoot = appHost ? '.' + appHost.split('.').slice(-2).join('.') : '';
      if (action.protocol !== 'https:') return '';
      if (appHost && action.host !== appHost && action.host.slice(-appRoot.length) !== appRoot) return '';
      return action.href;
    } catch (e) { return ''; }
  }

  function submitQuote() {
    var form = hostQuery('#rfq_form');
    if (!form) { alert(t('errors.form_loading')); return; }
    var action = vendorAction(form);
    if (!action) { alert(t('errors.unexpected')); return; }

    var ourEmail = root.querySelector('[name="email"]');
    if (ourEmail && !ourEmail.value.trim()) { if (ourEmail.reportValidity) ourEmail.reportValidity(); else ourEmail.focus(); return; }

    try {
    var val = function (name) { var el = root.querySelector('[name="' + name + '"]'); return el ? el.value.trim() : ''; };
    var set = function (el, v) { if (el) el.value = v; };
    set(form.querySelector('[name="additional_data[name]"]'), val('company'));
    set(form.querySelector('[name="additional_data[email]"]'), val('email'));
    set(form.querySelector('[name="additional_data[message]"]'), val('message'));
    set(form.querySelector('.cart__footer input[type="number"], input[type="number"]'), val('phone'));
    var urgent = (root.querySelector('[name="urgency"]:checked') || {}).value === 'urgent';
    Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]'), function (r) {
      var yes = /urgent|yes/i.test(r.value) && !/not|no,/i.test(r.value);
      r.checked = urgent ? yes : !yes;
    });

    // GRFQ submit: cross-domain FormData POST → JSON, handled in-page.
    var fd = new FormData(form);
    var qid = quoteId();
    if (qid) fd.append('quote', qid);
    fd.append('shop', SHOP);

    if (submitBtn) submitBtn.disabled = true;
    fetch(action, { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.success) {
          fillConfirmation();
          clearQuoteCookie();
          state.items = [];
          show('submitted');
          refreshQuoteBadge();
          // Fire the analytics event only on a confirmed submission.
          if (window.Tracker && Tracker.helpers && typeof Tracker.helpers.push === 'function') {
            Tracker.helpers.push('submit_quote_request', {});
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          if (submitBtn) submitBtn.disabled = false;
          alert(t('errors.submit_failed'));
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        alert(t('errors.network'));
      });
    } catch (e) {
      if (submitBtn) submitBtn.disabled = false;
      alert(t('errors.unexpected'));
    }
  }

  /* =============================================================
     EVENTS & BOOT
     ============================================================= */
  var submitBtn = root.querySelector('[data-quote-submit]');

  document.addEventListener('click', function (e) {
    try {
      var addBtn = e.target.closest('[data-sku-add], [data-quote-add-submit]');
      if (addBtn) { e.preventDefault(); addFromGroup(addBtn.closest('[data-quote-add]')); return; }

      var rm = e.target.closest('[data-item-remove]');
      if (rm) { e.preventDefault(); removeItem(rm.getAttribute('data-item-id')); return; }

      var view = e.target.closest('[data-view-quote]');
      if (view) { e.preventDefault(); viewQuote(view.getAttribute('data-view-quote')); return; }

      if (e.target.closest('[data-quote-detail-close]')) { e.preventDefault(); hideDetail(); return; }

      if (e.target.closest('[data-quote-submit]')) { e.preventDefault(); submitQuote(); }
    } catch (err) { /* a single action failing must not break the page */ }
  });

  var ourForm = root.querySelector('[data-quote-form]');
  if (ourForm) ourForm.addEventListener('submit', function (e) { e.preventDefault(); if (!submitBtn || !submitBtn.disabled) submitQuote(); });

  if (listEl) listEl.addEventListener('change', function (e) {
    try {
      var input = e.target.closest('[data-item-qty]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 1;
      if (qty < 1) { qty = 1; input.value = 1; }
      updateQty(input.getAttribute('data-item-id'), qty);
    } catch (err) {}
  });

  var terms = root.querySelector('[data-quote-accept]');
  if (terms && submitBtn) { var sync = function () { submitBtn.disabled = !terms.checked; }; terms.addEventListener('change', sync); sync(); }

  document.addEventListener('GRFQ_quote_page_loaded', render);

  /* Handoff — another page seeds this quote through the query string.
   *
   *   q=<free text>     a manual line, repeatable
   *   handle=<product>  a catalog line, repeatable
   *   note=<text>       prefills the message field
   *   email=<address>   prefills the email field
   *
   * The manufacturers directory sends one q. The cross-reference pages send a
   * handle for every replacement we stock, a q for every candidate we do not,
   * and a note naming the part being replaced, never the discontinued number
   * itself as a line, because that is the one part we cannot supply. `part` is
   * the older single-value spelling of `q` and is still read so existing links
   * keep working.
   *
   * Every q / part / handle value must look like a part number or a product
   * handle (HANDOFF_RE). Anything else is never added on the visitor's behalf;
   * it is placed in the part-number field for them to review.
   */
  var HANDOFF_RE = /^[A-Za-z0-9 ._\/+#()-]{1,80}$/;
  function validHandoff(value) { return HANDOFF_RE.test(value); }
  function prefillSkuInput(value) {
    var clean = String(value || '').replace(/[\u0000-\u001f]/g, '').slice(0, 120);
    if (!clean) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sku-input]'), function (input) {
      if (!input.value.trim()) input.value = clean;
    });
  }
  function clearHandoffParams() {
    try {
      var url = new URL(location.href);
      ['q', 'email', 'part', 'handle', 'note'].forEach(function (key) { url.searchParams.delete(key); });
      var qs = url.searchParams.toString();
      history.replaceState({}, '', url.pathname + (qs ? '?' + qs : '') + url.hash);
    } catch (e) {}
  }

  function waitForJQ(tries) {
    tries = tries == null ? 40 : tries;
    if ($jq()) return Promise.resolve($jq());
    if (tries <= 0) return Promise.resolve(null);
    return new Promise(function (resolve) {
      setTimeout(function () { resolve(waitForJQ(tries - 1)); }, 100);
    });
  }

  function sameText(a, b) {
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  /* Is this line already on the quote?
   *
   * A handoff link is re-openable by nature — bookmarked, re-entered, restored
   * with the tab, reached again through the back button — and GRFQ merges a
   * repeat add of the same product into its quantity. Without this, re-opening
   * the link quietly quotes two of the drive. Quantity is the stepper's job.
   * Nothing is remembered between visits: the check reads the live basket, so
   * once a quote is submitted and the basket is empty the same link works
   * again. */
  function onQuoteByHandle(handle) {
    return state.items.some(function (i) { return sameText(i.handle, handle); });
  }
  function onQuoteByName(name) {
    return state.items.some(function (i) { return sameText(i.title, name); });
  }

  // A handed-off handle is a real store product, so put it on the quote as
  // one — price, SKU and image — rather than as text someone has to look up.
  // If the product will not resolve (unpublished, renamed) the line still goes
  // on, as free text, because losing it silently is the worse failure.
  function addByHandle(handle) {
    return fetchProduct(handle).then(function (prod) {
      if (!prod) return onQuoteByName(handle) ? null : addCustom(handle, 1);
      // Second guard: a GRFQ row that carries no product link parses with no
      // handle, so the handle check cannot see it — the title still can.
      if (onQuoteByName(prod.title)) return null;
      var v = (prod.variants || [])[0] || {};
      return addProduct({
        productId: prod.id,
        variantId: v.id,
        title: prod.title || handle,
        qty: 1,
        handle: handle,
        image: prod.featured_image || (prod.images || [])[0],
        sku: v.sku,
        vendor: prod.vendor,
        price: v.price,
        option: v.title
      });
    });
  }

  function trimmedParams(params, key) {
    return params.getAll(key)
      .map(function (v) { return (v || '').trim(); })
      .filter(Boolean);
  }

  function applyHandoffParams() {
    var params = new URLSearchParams(location.search);
    var rejected = [];
    var keep = function (v) { if (validHandoff(v)) return true; rejected.push(v); return false; };
    var terms = trimmedParams(params, 'q').concat(trimmedParams(params, 'part')).filter(keep);
    var handles = trimmedParams(params, 'handle').filter(keep);
    if (rejected.length) prefillSkuInput(rejected[0]);
    var email = (params.get('email') || '').trim();
    var note = (params.get('note') || '').trim();
    if (!terms.length && !handles.length && !email && !note) {
      if (rejected.length) clearHandoffParams();
      return Promise.resolve();
    }

    if (email) {
      var emailInput = root.querySelector('input[name="email"]');
      if (emailInput) emailInput.value = email;
    }

    // Never overwrite something the visitor has already typed.
    if (note) {
      var messageInput = root.querySelector('[name="message"]');
      if (messageInput && !messageInput.value.trim()) messageInput.value = note;
    }

    if (!terms.length && !handles.length) {
      clearHandoffParams();
      return Promise.resolve();
    }

    // Checked as each step runs, not up front, so the basket it reads includes
    // the lines this same handoff has just added — a URL naming one part twice
    // still adds it once.
    var queue = handles.map(function (h) {
      return function () { return onQuoteByHandle(h) ? null : addByHandle(h); };
    }).concat(terms.map(function (term) {
      return function () { return onQuoteByName(term) ? null : addCustom(term, 1); };
    }));

    return waitForJQ().then(function () {
      // Strictly sequential: the first /add is what mints the quote id every
      // later call has to carry, so overlapping them would scatter the lines
      // across several quotes. One line failing must not drop the rest.
      return queue.reduce(function (chain, step) {
        return chain.then(step).catch(function () {});
      }, Promise.resolve());
    }).then(function () {
      clearHandoffParams();
      show('items');
    });
  }

  show('loading');
  var boot = quoteId() ? refresh() : Promise.resolve().then(function () { render(); });
  boot.then(applyHandoffParams);
  setTimeout(function () {
    var loading = root.querySelector('[data-quote-screen="loading"]');
    if (loading && !loading.classList.contains('hidden')) render();
  }, 8000);
})();
